module.exports = __webpack_public_path__ + "static/img/userLogo.326f960.png";


//////////////////
// WEBPACK FOOTER
// ./static/userLogo.png
// module id = siVn
// module chunks = 1